import { environment } from 'environments/environment';

// Non-scoped routes
export const ACCEPT_ROUTE = 'accept';
export const AUTH_LOGIN_ROUTE = 'sign-in';
export const AUTH_LOGOUT_ROUTE = 'sign-out';
export const FORGOT_PASSWORD_ROUTE = 'forgot-password';
export const REGISTER_ROUTE = 'register';
export const AUTH_REGISTER_ROUTE = 'auth/register'; // Old route, kept for backward compatibility
export const RESET_PASSWORD_ROUTE = 'reset-password';

// Scoped routes (Requires at least one `[scope]:read` permission)
export const ACCOUNT_ROUTE = 'account';
export const COMMISSIONS_ROUTE = 'commissions';
export const CUSTOMERS_ROUTE = 'customers';
export const DEVELOPERS_ROUTE = 'developers';
export const DISPUTES_ROUTE = 'disputes';
export const DOCUMENTS_ROUTE = 'documents';
export const ENROLL_ROUTE = 'enroll';
export const HOMEPAGE_ROUTE = 'dashboard';
export const INDEPENDENT_CREDITS_ROUTE = 'standalone-refunds';
export const MERCHANTS_ROUTE = 'merchants';
export const ONBOARDING_ROUTE = 'onboarding';
export const OUTBOUND_TRANSFERS_ROUTE = 'outbound-transfers';
export const PAYMENTS_ROUTE = 'payments';
export const PAYOUTS_ROUTE = 'payouts';
export const PRICING_TEMPLATES_ROUTE = 'pricing-templates';
export const REPORTS_ROUTE = 'reports';
export const SOFTWARE_PLATFORMS_ROUTE = 'software-platforms';
export const TERMINALS_ROUTE = 'terminals';

// Constants used throughout the application (Not related to routing)
export const DEFAULT_PAGE_LIMIT = 25;
export const DEFAULT_PAGE_SIZE_OPTIONS = [25, 50, 100];
export const USE_PAYSAFE_SANDBOX = environment.env === 'prod' ? false : true;
export const CARD_TERMS_LINK_NAME = 'Card Terms and Conditions';
export const PORTAL_TERMS_LINK_NAME = 'Portal Terms and Conditions';
export const ACH_DEBIT_TERMS_LINK_NAME = 'ACH Debit Terms and Conditions';
export const PRIVACY_POLICY_LINK_NAME = 'Privacy Policy';
export const TILLED_APP_BOX_LINK =
  environment.env === 'prod' ? 'https://tilled.app.box.com/f/5d654157d43d4d879bb2c5cf52f173c5' : '';
export const ULD_TABLE_NAME = 'user_local_data';
export const RECENT_MERCHANTS = 'recent_merchants';
export const USER_LOCAL_DATA = 'user_local_data';
